module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    key: _vm.src,
    ref: "video",
    attrs: {
      "controls": "",
      "muted": "",
      "autoplay": "",
      "playsinline": "",
      "src": _vm.src
    },
    domProps: {
      "muted": true
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66b4651d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/devices/Player.vue
// module id = 1156
// module chunks = 2